import { render, staticRenderFns } from "./departmentTree.vue?vue&type=template&id=73b59cb4&scoped=true"
import script from "./departmentTree.vue?vue&type=script&lang=js"
export * from "./departmentTree.vue?vue&type=script&lang=js"
import style0 from "./departmentTree.vue?vue&type=style&index=0&id=73b59cb4&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b59cb4",
  null
  
)

export default component.exports